import React from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * NavigateBackButton component renders a clickable icon that allows users
 * to navigate back in the browser history. If there's a previous entry in
 * the history stack, it navigates back; otherwise, it navigates to the specified URL.
 *
 * @param {string} url - The URL to navigate back to. Defaults to the root path ('/').
 * @returns {JSX.Element} - A clickable icon for navigating back.
 *
 * @example
 * To use this component, import it and use it in your JSX like this:
 * <NavigateBackButton url="/previousPage" />
 */

type Props = {
  url?: string
}

export const NavigateBackButton: React.FC<Props> = ({ url = '/' }) => {
  const navigate = useNavigate()

  const navigateBack = (url: string) => {
    if (url && url !== '/') {
      navigate(url)
    } else if (window.history.state && window.history.state.idx > 0) {
      navigate(-1)
    } else {
      navigate('/', { replace: true })
    }
  }

  return (
    <div className="cursor-pointer mr-2" onClick={() => navigateBack(url)}>
      <i className="pi pi-angle-left text-primary text-4xl"></i>
    </div>
  )
}
